<template>
    <v-card-actions>
        <p v-if="$isDesktop() && editorFlightLegMode === 'rotation'" class="mb-0 ml-3 font-weight-bold">
            Rotation
        </p>
        <p v-if="$isDesktop() && editorFlightLegMode === 'single'" class="mb-0 ml-3 font-weight-bold">
            Single
        </p>

        <div v-if="$isDesktop()" class="mx-5" style="width:1px; height:100%; background: #D7D8DA;" />

        <!-- input_FlightDateType: 0 = Dates, 1 = Weekly -->
        <p v-if="$isDesktop() && editorMode === 'create'" class="font-weight-bold mb-0">
            {{ counter }} Series Dates
        </p>

        <p v-if="$isDesktop() && editorMode === 'update' || editorMode === 'combine'" class="font-weight-bold mb-0" style="width: 200px;">
            Selected Flights: {{ counter }}
        </p>


        <div v-if="$isDesktop()" class="mx-5" style="width:1px; height:100%; background: #D7D8DA;" />


        <!-- >>> Fist Leg -->
        <div v-if="$isDesktop()">
            <p style="color: #92949C; font-size: 0.8rem; width: 100px;" class="mb-1">
                First Leg

                <span v-if="crudData.firstLeg.input_FlightTypeTab === 0" style="color: #9D9FA6;">Direct</span>
                <span v-if="crudData.firstLeg.input_FlightTypeTab === 1" style="color: #9D9FA6;">VIA</span>
                <span v-if="crudData.firstLeg.input_FlightTypeTab === 2" style="color: #9D9FA6;">TRIA</span>
            </p>
            <div style="display: flex; flex-direction: row;">
                <!-- DIRECT DEPARTURE AIRPORT -->
                <div v-if="crudData.firstLeg.input_FlightTypeTab === 0 && crudData.firstLeg.input_directFlight_AirportDeparture !== '' && crudData.firstLeg.input_directFlight_AirportDeparture !== undefined && crudData.firstLeg.input_directFlight_AirportDeparture !== null" style="display: flex; flex-direction: row;">
                    <v-icon class="mr-1">
                        mdi-airplane-takeoff
                    </v-icon>
                    <p class="mb-0 mr-4">
                        {{ crudData.firstLeg.input_directFlight_AirportDeparture.aptCode }}
                    </p>
                </div>

                <!-- VIA DEPARTURE AIRPORT -->
                <div v-if="crudData.firstLeg.input_FlightTypeTab === 1 && crudData.firstLeg.input_viaFlight_AirportDeparture !== '' && crudData.firstLeg.input_viaFlight_AirportDeparture !== undefined && crudData.firstLeg.input_viaFlight_AirportDeparture !== null" style="display: flex; flex-direction: row;">
                    <v-icon class="mr-1">
                        mdi-airplane-takeoff
                    </v-icon>
                    <p class="mb-0 mr-4">
                        {{ crudData.firstLeg.input_viaFlight_AirportDeparture.aptCode }}
                    </p>
                </div>

                <!-- TRIA DEPARTURE AIRPORT -->
                <div v-if="crudData.firstLeg.input_FlightTypeTab === 2 && crudData.firstLeg.input_triaFlight_AirportDestinationDeparture !== '' && crudData.firstLeg.input_triaFlight_AirportDestinationDeparture !== undefined && crudData.firstLeg.input_triaFlight_AirportDestinationDeparture !== null" style="display: flex; flex-direction: row;">
                    <v-icon class="mr-1">
                        mdi-airplane-takeoff
                    </v-icon>
                    <p class="mb-0 mr-4">
                        {{ crudData.firstLeg.input_triaFlight_AirportDestinationDeparture.aptCode }}
                    </p>
                </div>

                <div style="display: flex; flex-direction: row;">
                    <!-- DIRECT ARRIVAL AIRPORT -->
                    <div v-if="crudData.firstLeg.input_FlightTypeTab === 0 && crudData.firstLeg.input_directFlight_AirportDestination !== '' && crudData.firstLeg.input_directFlight_AirportDestination !== undefined && crudData.firstLeg.input_directFlight_AirportDestination !== null" style="display: flex; flex-direction: row;">
                        <v-icon class="mr-1">
                            mdi-airplane-landing
                        </v-icon>
                        <p class="mb-0 mr-4">
                            {{ crudData.firstLeg.input_directFlight_AirportDestination.aptCode }}
                        </p>
                    </div>

                    <!-- VIA ARRIVAL AIRPORT -->
                    <div v-if="crudData.firstLeg.input_FlightTypeTab === 1 && crudData.firstLeg.input_viaFlight_AirportVia !== '' && crudData.firstLeg.input_viaFlight_AirportVia !== undefined && crudData.firstLeg.input_viaFlight_AirportVia !== null" style="display: flex; flex-direction: row;">
                        <v-icon class="mr-1">
                            mdi-airplane-landing
                        </v-icon>
                        <p class="mb-0 mr-4">
                            {{ crudData.firstLeg.input_viaFlight_AirportVia.aptCode }}
                        </p>
                    </div>

                    <!-- TRIA ARRIVAL AIRPORT -->
                    <div v-if="crudData.firstLeg.input_FlightTypeTab === 2 && crudData.firstLeg.input_triaFlight_AirportFirstVia !== '' && crudData.firstLeg.input_triaFlight_AirportFirstVia !== undefined && crudData.firstLeg.input_triaFlight_AirportFirstVia !== null" style="display: flex; flex-direction: row;">
                        <v-icon class="mr-1">
                            mdi-airplane-landing
                        </v-icon>
                        <p class="mb-0 mr-4">
                            {{ crudData.firstLeg.input_triaFlight_AirportFirstVia.aptCode }}
                        </p>
                    </div>
                </div>
                <div style="display: flex; flex-direction: row;">
                    <!-- VIA ARRIVAL AIRPORT #2 -->
                    <div v-if="crudData.firstLeg.input_FlightTypeTab === 1 && crudData.firstLeg.input_viaFlight_AirportDestination !== '' && crudData.firstLeg.input_viaFlight_AirportDestination !== undefined && crudData.firstLeg.input_viaFlight_AirportDestination !== null" style="display: flex; flex-direction: row;">
                        <v-icon class="mr-1">
                            mdi-airplane-landing
                        </v-icon>
                        <p class="mb-0 mr-4">
                            {{ crudData.firstLeg.input_viaFlight_AirportDestination.aptCode }}
                        </p>
                    </div>

                    <!-- TRIA ARRIVAL AIRPORT #2 -->
                    <div v-if="crudData.firstLeg.input_FlightTypeTab === 2 && crudData.firstLeg.input_triaFlight_AirportSecondVia !== '' && crudData.firstLeg.input_triaFlight_AirportSecondVia !== undefined && crudData.firstLeg.input_triaFlight_AirportSecondVia !== null" style="display: flex; flex-direction: row;">
                        <v-icon class="mr-1">
                            mdi-airplane-landing
                        </v-icon>
                        <p class="mb-0 mr-4">
                            {{ crudData.firstLeg.input_triaFlight_AirportSecondVia.aptCode }}
                        </p>
                    </div>
                </div>

                <!-- OVERNIGHT INDICATOR -->
                <v-icon v-if="crudData.firstLeg.input_overnight === true" color="warning" class="ml-4">
                    mdi-weather-night
                </v-icon>
            </div>
        </div>
        <!-- <<< Fist Leg -->

        <div v-if="$isDesktop()" class="mx-5" style="width:1px; height:100%; background: #D7D8DA;" />

        <!-- >>> Second Leg -->
        <div v-if="$isDesktop() && editorFlightLegMode==='rotation'">
            <p style="color: #92949C; font-size: 0.8rem; width: 100px;" class="mb-1">
                Second Leg

                <span v-if="crudData.secondLeg.input_FlightTypeTab === 0" style="color: #9D9FA6;">Direct</span>
                <span v-if="crudData.secondLeg.input_FlightTypeTab === 1" style="color: #9D9FA6;">VIA</span>
                <span v-if="crudData.secondLeg.input_FlightTypeTab === 2" style="color: #9D9FA6;">TRIA</span>
            </p>
            <div style="display: flex; flex-direction: row;">
                <!-- DIRECT DEPARTURE AIRPORT -->
                <div v-if="crudData.secondLeg.input_FlightTypeTab === 0 && crudData.secondLeg.input_directFlight_AirportDeparture !== '' && crudData.secondLeg.input_directFlight_AirportDeparture !== undefined && crudData.secondLeg.input_directFlight_AirportDeparture !== null" style="display: flex; flex-direction: row;">
                    <v-icon class="mr-1">
                        mdi-airplane-takeoff
                    </v-icon>
                    <p class="mb-0 mr-4">
                        {{ crudData.secondLeg.input_directFlight_AirportDeparture.aptCode }}
                    </p>
                </div>

                <!-- VIA DEPARTURE AIRPORT -->
                <div v-if="crudData.secondLeg.input_FlightTypeTab === 1 && crudData.secondLeg.input_viaFlight_AirportDeparture !== '' && crudData.secondLeg.input_viaFlight_AirportDeparture !== undefined && crudData.secondLeg.input_viaFlight_AirportDeparture !== null" style="display: flex; flex-direction: row;">
                    <v-icon class="mr-1">
                        mdi-airplane-takeoff
                    </v-icon>
                    <p class="mb-0 mr-4">
                        {{ crudData.secondLeg.input_viaFlight_AirportDeparture.aptCode }}
                    </p>
                </div>

                <div style="display: flex; flex-direction: row;">
                    <!-- DIRECT ARRIVAL AIRPORT -->
                    <div v-if="crudData.secondLeg.input_FlightTypeTab === 0 && crudData.secondLeg.input_directFlight_AirportDestination !== '' && crudData.secondLeg.input_directFlight_AirportDestination !== undefined && crudData.secondLeg.input_directFlight_AirportDestination !== null" style="display: flex; flex-direction: row;">
                        <v-icon class="mr-1">
                            mdi-airplane-landing
                        </v-icon>
                        <p class="mb-0 mr-4">
                            {{ crudData.secondLeg.input_directFlight_AirportDestination.aptCode }}
                        </p>
                    </div>

                    <!-- VIA ARRIVAL AIRPORT -->
                    <div v-if="crudData.secondLeg.input_FlightTypeTab === 1 && crudData.secondLeg.input_viaFlight_AirportVia !== '' && crudData.secondLeg.input_viaFlight_AirportVia !== undefined && crudData.secondLeg.input_viaFlight_AirportVia !== null" style="display: flex; flex-direction: row;">
                        <v-icon class="mr-1">
                            mdi-airplane-landing
                        </v-icon>
                        <p class="mb-0 mr-4">
                            {{ crudData.secondLeg.input_viaFlight_AirportVia.aptCode }}
                        </p>
                    </div>
                </div>
                <div style="display: flex; flex-direction: row;">
                    <!-- VIA ARRIVAL AIRPORT #2 -->
                    <div v-if="crudData.secondLeg.input_FlightTypeTab === 1 && crudData.secondLeg.input_viaFlight_AirportDestination !== '' && crudData.secondLeg.input_viaFlight_AirportDestination !== undefined && crudData.secondLeg.input_viaFlight_AirportDestination !== null" style="display: flex; flex-direction: row;">
                        <v-icon class="mr-1">
                            mdi-airplane-landing
                        </v-icon>
                        <p class="mb-0 mr-4">
                            {{ crudData.secondLeg.input_viaFlight_AirportDestination.aptCode }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- <<< Second Leg -->
        <v-spacer v-if="$isDesktop()" />
        <div style="display:flex;justify-content:end;width:100%;">
            <v-btn style="width:120px" depressed elevation="1" outlined color="#ab3b7a" @click="onClick_CloseSheet">
                Close
            </v-btn>
            <v-tooltip
                v-if="editorMode === 'combine' && activeStepper !== '4'"
                top
                :fixed="!$isDesktop()" :right="!$isDesktop()">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        style="width:120px;margin-left:8px"
                        depressed
                        elevation="1" color="primary"
                        :class="{ 'sdr-disabled': editorMode === 'combine' && activeStepper !== '4' }"
                        v-on="on"
                        @click="onClick_Save">
                        Save
                    </v-btn>
                </template>
                <span>
                    Available on Step 4
                </span>
            </v-tooltip>
            <v-btn
                v-else
                style="width:120px;margin-left:8px"
                depressed elevation="1"
                color="primary"
                @click="onClick_Save">
                Save
            </v-btn>
        </div>
    </v-card-actions>
</template>

<script>
    export default {
        name: 'ActionBar',

        /* >>> *************************************************************** / /* Props */
        props: {

            editorMode: String, // 'create', 'update'
            counter: Number, // number of active eventRecords
            editorFlightLegMode: String, // 'single', 'rotation'
            crudData: Object, // Inputs object
            activeStepper: String // Active Stepper

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {};

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> ***************************************************************** / /* Methods */
        methods: {

            /*******************************************************************
            * Listeners: Common
            *******************************************************************/
            /*******************************************************************
            * onClick_CloseSheet
            *
            * Desc:
            * Note:
            *
            */
            onClick_CloseSheet: function() {

                const me = this;


                me.$toc('>>> views/shared/components/core/Bottomsheet/ActionBar.vue >>> onClick_Save');
                me.$emit('close');

            }, // eo function onClick_CloseSheet()


            /*******************************************************************
            * onClick_Save
            *
            * Desc:
            * Note:
            *
            */
            onClick_Save: function() {

                const me = this;


                me.$toc('>>> views/shared/components/core/Bottomsheet/ActionBar.vue >>> onClick_Save');
                me.$emit('save');

            } // eo function onClick_Save()

        } // eo methods

    };
</script>

<style scoped>
    .sdr-disabled {
        background-color: rgba(0, 0, 0, 0.12) !important;
        color: rgba(0, 0, 0, 0.26) !important;
    }
</style>
